import React, { Component } from 'react';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Checkbox } from 'primereact/checkbox';
import { Card } from 'primereact/card';
import { toggleUsingCS } from '../../../../../services/apps/JobProfileService';
import { dispatchGraphqlErrors, growlErrors } from '../../../../../utils/NotificationUtil';
import { withGrowl } from '../../../../../components/GrowlNotifications';

const i18nMsg = defineMessages({
  sendInvite: {
    id: 'assessment.invite.send',
    defaultMessage: 'Send Invite',
  },
  sendRemind: {
    id: 'assessment.remind.send',
    defaultMessage: 'Send Reminder',
  },
  remove: {
    id: 'del_header.cs.spec',
    defaultMessage: 'Delete Concurrent Study',
  },
  previewInvite: {
    id: 'assessment.invite.preview',
    defaultMessage: 'Preview Invite',
  },
  previewRemind: {
    id: 'assessment.remind.preview',
    defaultMessage: 'Preview Remind',
  },
});

const getItemStatus = () => ({
  NEW: (
    <div className="status status-new is-active">
      <FormattedMessage id="candidate.status.NEW" defaultMessage="NEW" />
    </div>
  ),
  INVITED: (
    <div className="status status-invited is-active">
      <FormattedMessage id="candidate.status.INVITED" defaultMessage="INVITED" />
    </div>
  ),
  STARTED: (
    <div className="status status-started is-active">
      <FormattedMessage id="candidate.status.STARTED" defaultMessage="IN PROGRESS" />
    </div>
  ),
  DECLINED: (
    <div className="status status-declined is-active">
      <FormattedMessage id="candidate.status.DECLINED" defaultMessage="DECLINED" />
    </div>
  ),
  EXPIRED: (
    <div className="status status-expired is-active">
      <FormattedMessage id="candidate.status.EXPIRED" defaultMessage="EXPIRED" />
    </div>
  ),
  SUBMITTED: (
    <div className="status status-submited is-active">
      <FormattedMessage id="candidate.status.SUBMITTED" defaultMessage="ASSESSED" />
    </div>
  ),
});

class HintCSCard extends Component {
  constructor(props) {
    super(props);
    const { item } = this.props;
    this.state = {
      itemChecked: item.useForHints ? item.useForHints : false,
      csCardActions: [],
    };

    this.handlePreviewInviteEmail = this.handlePreviewInviteEmail.bind(this);
    this.handlePreviewRemindEmail = this.handlePreviewRemindEmail.bind(this);
  }

  componentDidMount() {
    const { item } = this.props;
    this.buildCsActions(item);
  }

  buildCsActions(item) {
    const {
      intl, onInvite, onReminder, onRemove,
    } = this.props;
    const { formatMessage } = intl;
    const csCardActions = [];
    const { status } = item.assessment;

    if (status === 'NEW') {
      const newAction = {
        label: formatMessage(i18nMsg.sendInvite),
        command: () => onInvite(item.respondent.id),
      };
      csCardActions.push(newAction);
    } else if (status === 'STARTED' || status === 'INVITED') {
      const newAction = {
        label: formatMessage(i18nMsg.sendRemind),
        command: () => onReminder(item.respondent.id),
      };
      csCardActions.push(newAction);
    }

    csCardActions.push(
      {
        label: formatMessage(i18nMsg.remove),
        command: () => onRemove(item.id),
      },
      {
        label: formatMessage(i18nMsg.previewInvite),
        command: () => this.handlePreviewInviteEmail(),
      },
      {
        label: formatMessage(i18nMsg.previewRemind),
        command: () => this.handlePreviewRemindEmail(),
      },
    );

    this.setState({ csCardActions });
  }

  async handleToggleCS(id) {
    const { growl, currentAccount, jobId } = this.props;
    const { itemChecked } = this.state;
    try {
      const response = await toggleUsingCS({
        isUsed: !itemChecked,
        id,
        jobProfileId: jobId,
        accountId: currentAccount,
      });
      this.setState({ itemChecked: response.toggleConcurrentStudy.value });
    } catch (err) {
      growlErrors(growl, err);
    }
  }

  handlePreviewInviteEmail() {
    const { item } = this.props;
    const { assessment } = item;
    window.open(assessment.previewInviteUrl, '_blank');
  }

  handlePreviewRemindEmail() {
    const { item } = this.props;
    const { assessment } = item;
    window.open(assessment.previewReminderUrl, '_blank');
  }

  render() {
    const { item, currentAccount } = this.props;
    if (!item) {
      return (
        <div className="card" data-t="cs-item">
          <div className="card-column card-addon">
            <FormattedMessage id="lbl.no_item" defaultMessage="No Item" />
          </div>
        </div>
      );
    }
    const status = item.status ? item.status : item.assessment.status;
    const resDetailLink = `/accounts/${currentAccount}/respondents/${item.respondent.id}`;
    const { itemChecked, csCardActions } = this.state;
    return (
      <div className="p-grid">
        <div className="p-col">
          <Card>
            {
              // eslint-disable-next-line max-len
              status === 'SUBMITTED' && <Checkbox checked={itemChecked} onChange={() => this.handleToggleCS(item.id)} />
            }

            <Link to={resDetailLink} className="card-title">
              {item.respondent.firstName}
              {' '}
              {item.respondent.lastName}
            </Link>
            {' '}
            {status && getItemStatus()[status]}
            <br />
            {item.respondent.email}
          </Card>
        </div>

        <div className="p-col-2 p-col-align-center">
          <Menu
            model={csCardActions}
            popup
            appendTo={document.body}
            ref={(el) => {
              this.menu = el;
            }}
          />
          <Button
            className="p-button-secondary"
            icon="pi pi-ellipsis-h"
            onClick={(event) => {
              this.menu.toggle(event);
            }}
          />
        </div>
      </div>
    );
  }
}

HintCSCard.propTypes = {
  item: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    formatDate: PropTypes.func.isRequired,
  }).isRequired,
  growl: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  jobId: PropTypes.string.isRequired,
  onInvite: PropTypes.func.isRequired,
  onReminder: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  onActionFailed: (graphqlResponse) => {
    dispatchGraphqlErrors(dispatch, graphqlResponse);
  },
});

export default injectIntl(
  withGrowl(
    connect(
      null,
      mapDispatchToProps,
    )(HintCSCard),
  ),
);
